import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import components
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import CreateQR from './components/CreateQR';
import ViewQR from './components/ViewQR';
import UpdateQR from './components/UpdateQR';
import Login from './components/Login';
import AdminPage from './components/AdminPage';
import ProtectedRoute from './components/ProtectedRoute';
import CustomRouter from './CustomRouter';

// Import AuthProvider
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/create" element={
                <ProtectedRoute>
                  <CreateQR />
                </ProtectedRoute>
              } />
              <Route path="/adm" element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              } />
              <Route path="/*" element={<CustomRouter />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
